<div class="dialog-overlay d-overlay">
  <div class="dialog">
    <div class="dialog-header">
      <div class="dialog-title">{{ title }}</div>
      <!-- <button type="button" class="dialog-close" (click)="close()">X</button> -->
    </div>
    <div class="dialog-body">
      @if (listData.length > 0) { @for (list of listData; track list; let i =
      $index) {
      <div class="check-list" (change)="handleChange(list)">
        <input
          type="radio"
          name="filetype"
          value="{{ list['value'] }}"
          id="{{ i }}"
        />
        <label for="{{ i }}">{{ list["label"] }}</label>
      </div>
      } }
    </div>
    <div class="dialog-footer">
      <button class="btn btn-outline-primary" (click)="Cancel()">
        {{ btnCancelText }}
      </button>
      <button class="btn btn-outline-primary" (click)="Confirm()">
        {{ btnOkText }}
      </button>
    </div>
  </div>
</div>
